import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

function authHeaders() {
  const userData = JSON.parse(localStorage.getItem("userData") || "null");
  return {
    Authorization: `Bearer ${userData?.token}`,
  };
}

export const getNotificationsService = async ({
  unreadOnly = true,
  page = 1,
  limit = 20,
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
    unread_only: String(Boolean(unreadOnly)),
  });

  return axios
    .get(`${BASE_URL}notifications?${params}`, { headers: authHeaders() })
    .then((response) => response)
    .catch((error) => error.response);
};

export const markNotificationReadService = async (id) => {
  return axios
    .post(`${BASE_URL}notifications/mark-read`, { id }, { headers: authHeaders() })
    .then((response) => response)
    .catch((error) => error.response);
};

export const markAllNotificationsReadService = async () => {
  return axios
    .post(`${BASE_URL}notifications/mark-all-read`, {}, { headers: authHeaders() })
    .then((response) => response)
    .catch((error) => error.response);
};

